const userReducer = (state = null, action) => {
    switch (action.type) {
      case "GET_USER":
        return state;
      case "SET_USER":
        return action.user;
      case "NULL_USER":
        return null;
      case "UPDATE_USER_IMAGE_URL":
        return {
          ...state,
          image_url: action.image_url, // Only update the image_url property
        };
      default:
        return state;
    }
  };
  
  export default userReducer;
  
